import styled from '@emotion/styled';

import { linkWithUnderlineHover } from 'styles/mixins';

const Wrapper = styled.div`
  padding: 3rem 0;
  background: ${(props) => props.theme.mainColors.secondary};
  color: ${(props) => props.theme.colorMono.white};
  text-align: center;

  p {
    white-space: break-spaces;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  a {
    ${linkWithUnderlineHover('&', 1)};
  }
`;

export {
  Wrapper
};
